import { mapGetters, mapActions } from "vuex";

const lead = {
    data() {
        return {
            addminssionTermsLoading: true,
            addminssionTermsLoadingMore: false
        }
    },
    computed: {
        lead: {
            get() {
                return this.$store.state.lead.lead
            },
            set(payload) {
                this.$store.commit('lead/setLead', payload)
            }
        },
        validation: {
            get() {
                return this.$store.state.lead.validation
            },
            set(payload) {
                this.$store.commit('lead/setValidation', payload)
            }
        },
        ...mapGetters({
            getFirstPossibleDate: 'definitions/getFirstPossibleDate',
            getOperations: 'definitions/getOperations',
            getAdvisonGroups: 'definitions/getAdvisonGroups',
            getAdvisonGroups: 'definitions/getAdvisonGroups',
            getAdditionalOptions: 'definitions/getAdditionalOptions',
            getLeadSelectedGroupIds: 'definitions/getLeadSelectedGroupIds'
        }),
        nextDay() {
            var date = this.getFirstPossibleDate;
            date.setHours(date.getHours());
            return date.toISOString().split('T')[0]
        },
        nextTime() {
            var date = this.getFirstPossibleDate;
            var hours = Number(date.toISOString().split('T')[1].split(':')[0])
            return hours;
        },
        getTotalAdditionalTime() {
            const time = this.getAdditionalOptions
                .filter(option => this.lead.additional_options_val.includes(option.val))
                .reduce((acc, option) => {
                    const time = (option.default && option.default.mechanic_time) ? option.default.mechanic_time : 0;
                    return acc + time;
                }, 0);
                
            return time;
        },
        getSummaryServicesTime() {
            let time = this.lead.services_val.reduce((acc, service) => {
                const serviceTime = this.getOperations.find(op => op.id === service).time;
                return acc + serviceTime;
            }, 0);

            let additionalTime = this.getTotalAdditionalTime;
            let leadTime = 0;
  

            leadTime = time > 120 ? 120 : time; // Limit to 2 hours


            this.lead.mechanic_time = leadTime; // Set mechanic time in lead
            // if additional options are selected, add their time when  greater than the service time summary            
            if (time >= additionalTime && additionalTime > 0) {
                this.lead.mechanic_time = additionalTime;
            }

            // to client return full time
            return time;

        },
        getSummaryServicesTimeText() {
            const total = this.getSummaryServicesTime
            const hours = Math.floor(total / 60)
            const minutes = total % 60
            return `${hours} godz.  ${minutes} min.`
        }
    },
    methods: {
        ...mapActions({
            fetchServiceAdmissionTerms: "definitions/fetchServiceAdmissionTerms",
            clearLeadResponse: "lead/clearLeadResponse"
        }),
        scrollToTop() {
            window.scrollTo(0, 0);
        },
        validate() {

            const requiredService = [
                'services_val',
                //'dealer_id',
                // 'visit_hour_val',
                'additional_options_val',
                // 'date_from'
            ];

            this.validation.service = requiredService.every((e) => {
                return !!this.lead[e] && this.lead[e] != '';
            });

            if(this.lead.additional_options_val.includes('Potrzebuje mobilności')) {
                this.validation.service = this.lead.subAdditionalOptions.length > 0
            }

            const requiredClient = [
                'email',
                'phone_number',
                'accept1_val',
                'first_name',
                'last_name'
            ];

            const requiredVisit = [
                'hour',
                'date'
            ];

            this.validation.visit = requiredVisit.every((e) => {
                return !!this.lead[e];
            });



            this.validation.client = requiredClient.every((e) => {
                return !!this.lead[e];
            });

            const requiredCar = [
                'registration_number',
            ];

            this.validation.car = requiredCar.every((e) => {
                return !!this.lead[e];
            });
        },
        getDayofWeek(date) {
            var r = new Date(Date.parse(date));
            return r.getDay();
        },
        getDayNameOfWeek(date) {
            return ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'][this.getDayofWeek(date)]
        },
        fetchTerms(params) {
            this.loading = true;
            this.lead.date = null;
            this.lead.hour = null;
            this.lead.advisor_id = null;
            this.lead.term_key = null;
            this.lead.repair = null;
            this.lead.mechanic_id = null;
            this.lead.mechanic_hour = null;

            this.clearLeadResponse();
            let request = {};
            Object.keys(this.lead).map((k) => {
                if (
                    [
                        "date_from",
                        "days",
                        "hour_from",
                        "hour_to",
                        "date_hour_from",
                        "dealer_id",
                        "mechanic_offset_max",
                        "mechanic_next_day_hour",
                        "operation_id",
                        "operation_group_id",
                        "mechanic_time"
                    ].includes(k)
                ) {
                    request[k] = this.lead[k];
                }
            });

            // CSF-9889 nie przesyłam że mechanik ma byc w tym samym dniu bo może być również jutro
            if (request.mechanic_next_day_hour) {
                request.mechanic_same_day = null
            }

            if (!request.date_from) {
                request.date_from = new Date().toISOString().split('T')[0];
            }

            request = { ...request, ...params };

            this.fetchServiceAdmissionTerms(request).then(() => {
                this.addminssionTermsLoading = false
                this.addminssionTermsLoadingMore = false
            });
        }
    },
    watch: {
        lead: {
            handler() {
                this.validate()
            },
            deep: true
        }
    }
}

export default lead;